namespace SorAraBul.Administration {
    export class PurchasePackageFeaturesColumns {
        static columnsKey = 'Administration.PurchasePackageFeatures';
    }
}
